import { render } from "./Expander.vue?vue&type=template&id=12da5a9a&scoped=true&lang=pug"
import script from "./Expander.vue?vue&type=script&lang=js"
export * from "./Expander.vue?vue&type=script&lang=js"

import "./Expander.vue?vue&type=style&index=0&id=12da5a9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12da5a9a"]])

export default __exports__